import { Component, Input, OnChanges, ViewChild } from '@angular/core';
import { MatTable, MatTableModule } from '@angular/material/table';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Policy, ReservationInsurancePolicyColumns } from '../../../../policies/models/Policy';
import { VerificationPackage } from '../../../../verification-packages/models/VerificationPackage';

@Component({
  selector: 'app-review-all',
  templateUrl: './review-all.component.html',
  styleUrls: ['./review-all.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatIcon,
    MatTableModule,
  ]
})
export class ReviewAllComponent implements OnChanges {

  @Input('policyTableData') policyTableData!: Policy;
  @Input('verificationPackage') verificationPackage!: VerificationPackage;
  @Input('primaryPolicyPricingModel') primaryPolicyPricingModel!: string;
  @Input('insuranceCost') insuranceCost!: number;
  @Input('insurancePolicyPrice') insurancePolicyPrice!: number;
  @Input('verificationCost') verificationCost!: number;
  @Input('numberOfNightsFrom') numberOfNightsFrom!: number;
  @Input('numberOfNightsTo') numberOfNightsTo!: number;
  @Input('extraNights') extraNights!: number;
  @Input('extraNightsPrice') extraNightsPrice!: number;

  @ViewChild(MatTable) table!: MatTable<any>;

  title: string = "Insurance Cost Summary";
  panelOpen: boolean = false;
  complete: boolean = false;
  error: boolean = false;
  icon: string = "expand_more";
  totalCost: number = 0;
  dataSource: Policy[] = [];
  public columnsProps: string[] = ReservationInsurancePolicyColumns.map((column: any) => column.column);

  constructor() { }

  ngOnChanges() {
    if(this.policyTableData) {
      this.dataSource = [this.policyTableData];
    }
    this.totalCost = this.insuranceCost + this.verificationCost;

    this.table?.renderRows();
  }
}